import React from 'react';
import { useSetResolved } from 'src/core/engine/router/useSetResolved';
import { Link } from 'react-router';

import { Container, Wrapper } from '../Layout';
import { PageTitle } from '../Layout/PageTitle';

import classes from './CategoryBrandPage.scss';
import { sortBrands } from './utils/utils';

export interface BrandItem {
    name: string;
    url_path: string;
}

export interface SortedBrands {
    title: string;
    children: {
        name: string;
        url_path: string;
    }[];
}

type Props = {
    brands: BrandItem[];
};

export const CategoryBrandPage: React.FunctionComponent<Props> = ({ brands }) => {
    useSetResolved();
    const sortedBrands = sortBrands(brands);
    return (
        <Wrapper element="section" variant="page-inner">
            <Container>
                <PageTitle title="Brands" />
                <div className={classes.brands}>
                    {sortedBrands.map((sortedBrand) => {
                        return (
                            <div key={sortedBrand.title} className={classes.brandsItem}>
                                <p className={classes.brandsListTitle}>{sortedBrand.title}</p>
                                <ul className={classes.brandsList}>
                                    {sortedBrand.children.map((brand) => {
                                        return (
                                            <li key={brand.name} className={classes.brandsListItem}>
                                                <Link to={brand.url_path} className={classes.brandsListLink}>
                                                    {brand.name}
                                                </Link>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        );
                    })}
                </div>
            </Container>
        </Wrapper>
    );
};
